import React, { FC, useEffect, useState } from 'react'
import useStore, { uiStore } from 'store'
import { saveCsvIsraeliIdErrors } from 'utils/csvUtils'
import styled from 'styled-components'
import { Dialog } from '@material-ui/core'
import MekomeTablePagination from 'components/MekomeTablePagination'
import { useTranslation } from 'react-i18next'
import { theme, Button, Text, Spinner } from 'ui'
import { observer } from 'mobx-react'
import { snackBar } from 'store'
import MessagesHeader from 'components/Messages/MessagesHeader'
import Dropzone from 'react-dropzone'
import { Attachment, GetApp } from '@material-ui/icons'
import api from 'service/api'
import { ExportToCsv } from 'utils/export-to-csv'
import CsvListScreen from './CsvListScreen'

const ContainerDialog = styled.div`
    flex-direction:column;
    display:flex;
    height:80vh;
    max-height:1000px;
    width:90vw;
    max-width:1400px;
`
const DropArea = styled.div`
    border-radius: 4px;
    color: rgba(0,0,0,0.6);
    background: #fafafa;
    border: 1px dashed ${theme.color.gray};
    display: flex;
    justify-content:center;
    align-items: center;
    flex:1;
    height: 100%;
`
const DropAreaContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
`
const DropAreaIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
`
const EmptyState = styled.div`
  display: flex;
  gap: 20px;
  flex: 1;
  padding: 20px;
  height: 100%;
  align-items: stretch;

  @media (max-width: 900px) {
    flex-direction: column;
    overflow-y: auto;
  }
`
const Instructions = styled.div`
  flex: 0 0 380px;
  max-width: 380px;
  background: ${theme.color.whiteBackground};
  border: 1px solid ${theme.color.lightGrayBackground};
  border-radius: 12px;
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  text-align: right;

  @media (max-width: 900px) {
    flex: none;
    max-width: none;
  }
`
const InstrTitle = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: ${theme.color.mekomiBlack};
  margin-bottom: 8px;
`
const InstrText = styled.p`
  font-size: 14px;
  color: ${theme.color.base};
  margin: 0 0 12px;
  line-height: 1.55;
`
const ColList = styled.ol`
  margin: 0 0 12px;
  padding-inline-start: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  li {
    font-size: 14px;
    color: ${theme.color.base};
  }
  li b {
    color: ${theme.color.mekomiBlack};
  }
`
const InstrNote = styled.p`
  font-size: 13px;
  color: ${theme.color.grey};
  line-height: 1.55;
  margin: 0 0 18px;
`
const SampleButton = styled(Button)`
  &.MuiButtonBase-root {
    align-self: flex-start;
    text-transform: none;
    font-size: 14px;
    font-weight: 600;
    height: 42px;
    border-radius: 10px;
    padding: 0 18px;
    margin-top: auto;
    background: ${theme.color.white};
    color: ${theme.color.confirmButton};
    border: 1.5px solid ${theme.color.confirmButton};

    &:hover {
      background: ${theme.color.confirmButton}12;
    }
  }
`
const DropWrap = styled.div`
  flex: 1;
  display: flex;
  min-height: 260px;
`
const Container = styled.div<{ height: boolean }>`
    display:flex;
    width: 100%;
    height: ${p => p.height ? 'calc(100% - 90px)' : '100%'};
    flex-direction: column;
`
const ConfirmButton = styled(Button) <{ bgColor: string, hoverColor?: string }>`
  display: flex;
  width: max-content;
  &.MuiButtonBase-root {
    font-size: ${theme.fontSize.large};
    font-weight: 500;
    min-width: 140px;
    height: 50px;
    margin: 0.5rem;
    background:${p => p.bgColor};
    &:hover {
      background: ${p => p.hoverColor ? p.hoverColor : theme.color.darkBlue};
    }
    color: ${theme.color.white};
    &.Mui-disabled {
      opacity: 0.5;
    }
  }
`                    

const DropCsvView = ({ handleUpload }: { handleUpload: (fils: File[]) => void }) => {
    const { t } = useTranslation('members')

    return (
        <Dropzone
            onDrop={handleUpload}
            maxFiles={1}
            onDropRejected={(e) => {
                if (e && e[0]?.errors && e[0]?.errors[0]?.code === 'too-many-files') {
                    snackBar.showError(t`fileLimit`)
                }

                if (e && e[0]?.errors && e[0]?.errors[0]?.code === 'file-invalid-type') {
                    snackBar.showError(t`MessageDialog:notCSV`)
                }
            }}
            multiple={false}
        // accept={['text/csv']}
        >
            {({ getRootProps, getInputProps }) => (
                <DropArea {...getRootProps()}>
                    <input {...getInputProps()} />
                    <DropAreaContent>
                        <DropAreaIconsContainer>
                            <Attachment />
                        </DropAreaIconsContainer>
                        <Text align={'center'} textcolor={theme.color.black + 'A1'}>{t`dropCsv`}</Text>
                    </DropAreaContent>
                </DropArea>
            )}
        </Dropzone>
    )
}

const MapMemberWithSocialId: FC = ({ }) => {
    const { orgs, csvStore } = useStore()
    const { t } = useTranslation('members')
  
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(100)
    const [loading, setLoading] = useState(false)

    const closeModal = () => {
        csvStore.handleCSVMapSocialIdwithCntactModal(false)
        csvStore.clearCsvFileIsraelIds()
        csvStore.clearCsvFileIsraelIdErrors()
    }

    const downloadSample = () => {
        const headers = ['שם פרטי', 'שם משפחה', 'כינוי', 'מספר תעודת זהות', 'טלפון נייד', 'טלפון נייד נוסף', 'דוא"ל']
        const data = [
            { firstName: 'ישראל', lastName: 'ישראלי', nickName: 'ישי', israeliID: '123456789', phone1: '050-1234567', phone2: '', email: 'israel@example.com' },
            { firstName: 'שרה', lastName: 'כהן', nickName: '', israeliID: '987654321', phone1: '052-7654321', phone2: '', email: 'sarah@example.com' },
        ]

        const csvExporter = new ExportToCsv({
            fieldSeparator: ',',
            quoteStrings: '',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            filename: 'sample_israeli_ids',
            title: t`sample_title_social_id`,
            useTextFile: false,
            useBom: true,
            headers,
        })

        csvExporter.generateCsv(data)
    }

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
        csvStore.resolveCsvIsraelIdList(newPage, rowsPerPage)
    }

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);

        csvStore.resolveCsvIsraelIdList(0, parseInt(event.target.value, 10))
    }

    const handleOk = async () => {
        csvStore.clearCsvFileIsraelIdErrors()
        setLoading(true)

        try {
            const result = await api.uploadIsraelId(csvStore.getCsvSocialIds
                .filter(item => item.selected)
                .map(item => {
                  
                  let newItem = {
                    guid: item.guid,
                    israeliID: item.israeliID
                  }
                
                  if ('phone' in item) {
                    newItem['phone'] = item.phone
                  }

                  if ('email' in item) {
                    newItem['email'] = item.email
                  }
                    
                  return newItem
                }), 
                orgs.currentBrandId
            )

            const uploadErrors = result.reduce((acc: any, item: any) => {
                acc.set(item.guid, item)
                return acc;
            }, new Map()) 

            csvStore.setCsvFileIsraelIdErrors(uploadErrors)
            
            const failedRows = result.filter((item: any) => item.errorKey !== null)

            if (failedRows.length > 0 ) {
                console.log("")
                snackBar.showError(t`MessageDialog:errorsList`)
            } else {
                snackBar.showSuccess(t`updated_ok`)
            }

            setLoading(false)
        } catch (error) {
            snackBar.showError(t`MessageDialog:errorsList`)
            setLoading(false)
        }
    }

    const handleUpload = async (files: File[]) => {
        if (files.length != 1) {
            return
        }

        try {
            const { hasErrors, errors } = await csvStore.processCsvFileIsraelIds(files[0])

            if (hasErrors) {
                uiStore.openWarningModal({
                    text: t`MessageDialog:errorsList`,
                    secondText: t`export_errors_hint`,
                    okText: t`export_action`,
                    cancelText: t`close`,
                    cancelAction: () => {
                        closeModal()
                    },
                    okAction: () => {
                        saveCsvIsraeliIdErrors(errors, t);
                        closeModal()
                    }
                })    
            } else {
                csvStore.resolveCsvIsraelIdList(page, rowsPerPage)
            }
        } catch (error) {
            console.error(error)
            snackBar.showError(t`MessageDialog:errorsList`)
        }
    }

    return (
        <Dialog
            style={{ zIndex: 1200, overflow: 'hidden' }}
            open={csvStore.CSVMapSocialIdwithCntactModalOpen}
            maxWidth={'xl'}
        >
            <ContainerDialog>
                <MessagesHeader
                    disableIcon
                    textVarient={'black'}
                    backColor={theme.color.azureBlue + 33}
                    mainText={orgs.currentOrg.name}
                    secondText={t`mapSociaNumber`}
                    onClose={closeModal}
                />
                <Container height={csvStore.getRawCsvSocialIds.length > 0}>
                    {csvStore.getRawCsvSocialIds.length == 0 &&
                        <EmptyState>
                            <Instructions>
                                <InstrTitle>{t`file_structure`}</InstrTitle>
                                <InstrText>{t`file_structure_text`}</InstrText>
                                <ColList>
                                    <li>{t`col_given_name`}</li>
                                    <li>{t`col_family_name`}</li>
                                    <li>{t`col_nickname`}</li>
                                    <li><b>{t`col_identity`}</b></li>
                                    <li>{t`col_mobile`}</li>
                                    <li>{t`col_mobile_extra`}</li>
                                    <li>{t`col_email`}</li>
                                </ColList>
                                <InstrNote>{t`file_note_social_id`}</InstrNote>
                                <SampleButton onClick={downloadSample} startIcon={<GetApp />}>{t`download_sample`}</SampleButton>
                            </Instructions>
                            <DropWrap>
                                <DropCsvView handleUpload={handleUpload} />
                            </DropWrap>
                        </EmptyState>
                    }

                    {csvStore.getRawCsvSocialIds.length > 0 &&
                      <>
                        <CsvListScreen />
                        <MekomeTablePagination
                            disabled={false}
                            style={{ direction: 'ltr'}}
                            labelRowsPerPage=''
                            rowsPerPageOptions={[50, 100, 200, 300]}
                            component="div"
                            count={csvStore.getRawCsvSocialIds.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />

                        <ConfirmButton
                          disabled={loading}
                          bgColor={loading ? theme.color.confirmButton + 33 : theme.color.confirmButton}
                          onClick={handleOk}
                        >
                            {loading && <Spinner color="white" size="2rem"/>}   
                            {!loading && t`app:add`}
                        </ConfirmButton>
                      </>
                    }
                </Container>
            </ContainerDialog>
        </Dialog>
    )
}

export default observer(MapMemberWithSocialId)
